<template>
  <div class="scpm-tab-box" ref="tabBox">
    <div class="tab-box__container" ref="container" :style="{ marginLeft: -marginLeft + 'px' }">
      <div
        class="tab-box__item"
        v-for="(item, index) in props.items"
        :key="index"
        :class="{
          'tab-box__item--active':
            item['service.type'] === props.modelValue['service.type'] &&
            item.productResourceId === props.modelValue.productResourceId
        }"
        @click="() => changeItem(item)"
        :ref="(el) => (refItem[index] = el)"
      >
        <div
          class="tab-box__label"
          v-lego-tooltip:ellipsis="`${item.productName}:${item['service.type']}`"
        >
          {{ item.productName }}:
          {{ item['service.type'] }}
        </div>
      </div>
    </div>
    <div class="next-tab" v-if="pages.length > 1">
      <button class="box-icon icon__pre" @click="prePage" :disabled="pagesActive === 1">
        <NexIcon />
      </button>
      <div class="count">{{ `${pagesActive}/${pages.length}` }}</div>
      <button
        class="box-icon icon__next"
        @click="nextPage"
        :disabled="pagesActive === pages.length"
      >
        <NexIcon />
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, defineEmits, watch, nextTick } from 'vue';
import NexIcon from './nexIcon.vue';
import { isEqual } from 'lodash';

//emits
const emits = defineEmits(['update:modelValue']);

//props
const props = defineProps({
  items: { type: Array },
  modelValue: { type: [String, Number, Object] }
});

// data
const tabBox = ref();
const container = ref();
const pages = ref([]);
const pagesActive = ref(1);
const marginLeft = ref(0);
const refItem = ref([]);
// function

const nextPage = () => {
  if (pagesActive.value < pages.value.length) {
    marginLeft.value = marginLeft.value + pages.value[pagesActive.value - 1];
    pagesActive.value++;
  }
};
const prePage = () => {
  if (pagesActive.value > 1) {
    marginLeft.value = marginLeft.value - pages.value[pagesActive.value - 2];
    if (marginLeft.value < 0) {
      marginLeft.value = 0;
    }
    pagesActive.value--;
  }
};

const changeItem = (item) => {
  emits('update:modelValue', item);
};

const isPages = () => {
  try {
    return container.value.scrollWidth > tabBox.value.clientWidth;
  } catch (error) {
    return false;
  }
};

const updateTab = async () => {
  await nextTick();
  if (container.value) {
    getPage();
  }
};

const getPage = () => {
  pages.value = [];
  pagesActive.value = 1;
  marginLeft.value = 0;
  if (!isPages()) return;
  const page = [0];
  let indexPage = 0;
  // width next-page = 73
  const maxWidth = tabBox.value.clientWidth - 73;
  const listItem = refItem.value;
  for (let index = 0; index < listItem.length; index++) {
    const item = listItem[index];
    if (page[indexPage] < maxWidth && item) {
      page[indexPage] = page[indexPage] + item.clientWidth;
      if (page[indexPage] > maxWidth) {
        page[indexPage] = page[indexPage] - item.clientWidth;
        page[indexPage + 1] = item.clientWidth;
        indexPage++;
      }
    }
  }
  pages.value = page;
};

onMounted(() => {
  if (props.items.length > 0) {
    updateTab();
  }
});

watch(
  () => props.items,
  async (value, oldValue) => {
    if (!isEqual(value, oldValue)) {
      updateTab();
    }
  }
);
</script>

<style scoped lang="scss">
.scpm-tab-box {
  display: flex;
  height: 54px;
  border-bottom: 1px solid #e3e4e8;
  .tab-box__container {
    display: flex;
    overflow: hidden;
    flex: 1;
    transition: all 0.5s ease-in-out;
    .tab-box__item {
      width: max-content;
      height: 54px;
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: 400;
      font-size: 16px;
      color: #2e3138;
      user-select: none;
      &--active {
        color: #2c5ad8;
        border-bottom: 3px solid #2c5ad8;
        font-weight: 700;
      }
    }
    .tab-box__label {
      max-width: 500px;
      width: max-content;
      padding: 0 20px;
      display: block;
      font-style: normal;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .next-tab {
    width: 73px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    font-size: 12px;
    .icon__pre {
      transform: rotate(180deg);
    }
    .box-icon {
      display: flex;
      cursor: pointer;
      width: 9px;
      padding: 0;
      border-width: 0;
      background: #ffffff;
      &:disabled {
        cursor: unset;
        :deep(svg path) {
          fill: #aaaaaa;
        }
      }
    }
  }
}
</style>
